const CONFIG = {
  // 设备类型
  DEVICE_PC: 'pc',
  DEVICE_MOBILE: 'mobile',
  DEVICE_WECHAT: 'wechat',
  // 上报 事件 名, 务必与 REPORT_EVENT 中对应的key值保持 一致, 否则将导致util中 获取定制事件 公共参数 异常
  PAGE_START_LOADING_EVENT: 'PAGE_START_LOADING',
  DOWNLOAD_CLICK_EVENT: 'DOWNLOAD_CLICK',
  // 上报 事件 对应固定参数
  REPORT_EVENT: {
    PAGE_START_LOADING: {
      event_id: 'W090000',
      event_name: 'Webpage_Appstore_PageView',
    },
    DOWNLOAD_CLICK: {
      event_id: 'W090005',
      event_name: 'Webpage_Appstore_DownloadClick',
    }
  },
  PAGE_TYPE: {
    HOME: 1,
    INFO: 2,
  },
  DOWNLOAD_POSITION_DICTIONARY: {
    '主按钮': '主按钮',
    'GROUP': 'GROUP',
    '吸底': '吸底'
  },
  DOWNLOAD_APP_TIME: 2000 // ms
};

export default CONFIG;
